import Button from './src/JsmButton.vue'

Button.install = (Vue) => {
  Vue.component(Button.name, Button)
}

export default Button
